import { render, staticRenderFns } from "./seo.vue?vue&type=template&id=397577a6&scoped=true"
import script from "./seo.vue?vue&type=script&lang=js"
export * from "./seo.vue?vue&type=script&lang=js"
import style0 from "./seo.vue?vue&type=style&index=0&id=397577a6&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "397577a6",
  null
  
)

export default component.exports